import Vue from 'vue';
import VueI18n from 'vue-i18n';
import english from './lang/english';
import russian from './lang/russian';
import spanish from './lang/spanish';
import kazakh from './lang/kazakh';
import ukrainian from './lang/ukrainian';
import vietnamese from './lang/vietnamese';

import settings from '../environment';

Vue.use(VueI18n);

const lang = process.env.VUE_APP_LOCALE;

const messages = {
  en: english,
  ru: russian,
  es: spanish,
  kz: kazakh,
  ua: ukrainian,
  vn: vietnamese,
};

messages[lang][lang] = Object.assign(messages[lang][lang], settings);
export default new VueI18n({
  locale: lang,
  messages: messages[lang],
});
